import React, { useEffect, useState } from 'react'
import ScheduleLayout from '../layout/ScheduleLayout'
import DaySchedule from '../components/DaySchedule';
import { businessDays } from '../scheduleServices';
import BusinessHourSetup from '../components/BusinessHourSetup';
import { CircularProgress } from '@mui/material';
import { useAppData } from '../../../../context/AppDataContext';



function BusinessHoursPage() {

    const [loading,setLoadingStatus] = useState(false);

    const { associateBusinessHours} = useAppData();

    const reload = () =>{
        
    }

    return (
        <ScheduleLayout>
            <BusinessHourSetup callBack={reload} />
            {associateBusinessHours?.length > 0 && businessDays.map((day,i)=> 
                <div key={i} className='card mb-2'>
                    <div className='card-header'><span className='fw-bold'>{day}</span></div>
                    <div className='card-body p-1'>
                        <DaySchedule dayNo={i+1} />
                    </div>
                </div>
            )}

        </ScheduleLayout>
    )
}

export default BusinessHoursPage